// Keyboard Shortcuts Cheatsheet — press `?` (or Shift+/) to open.

import { theme } from "./prefs.js";
import { t } from "../utils/i18n.js";

const ROOT_ID = "e16-shortcuts-overlay";

const SHORTCUTS = [
	{ keys: ["⌘", "K"], en: "Open Command Palette", ar: "فتح لوحة الأوامر" },
	{ keys: ["?"],     en: "Show Keyboard Shortcuts", ar: "إظهار اختصارات لوحة المفاتيح" },
	{ keys: ["⌘", "S"], en: "Save current document", ar: "حفظ المستند الحالي" },
	{ keys: ["Esc"],   en: "Close modal / Cancel", ar: "إغلاق النافذة / إلغاء" },
	{ keys: ["G", "H"], en: "Go to Home", ar: "الذهاب إلى الرئيسية" },
	{ keys: ["G", "S"], en: "Go to Settings", ar: "الذهاب إلى الإعدادات" },
];

function close() {
	const r = document.getElementById(ROOT_ID);
	if (r) r.remove();
}

function open() {
	close();
	const lng = theme.currentLang();
	const isAR = lng === "ar";

	const root = document.createElement("div");
	root.id = ROOT_ID;
	root.className = "e16-cmdk-backdrop";
	root.setAttribute("role", "dialog");
	root.setAttribute("aria-modal", "true");

	const panel = document.createElement("div");
	panel.className = "e16-cmdk";
	panel.style.maxWidth = "560px";

	panel.innerHTML = `
		<div style="padding: 18px 22px 12px; border-bottom: 1px solid var(--e16-border);">
			<div style="font-size: 17px; font-weight: 600; color: var(--e16-text);">
				${isAR ? "اختصارات لوحة المفاتيح" : "Keyboard Shortcuts"}
			</div>
			<div style="font-size: 12px; color: var(--e16-text-muted); margin-top: 4px;">
				${isAR ? "اضغط Esc للإغلاق" : "Press Esc to close"}
			</div>
		</div>
		<div style="padding: 12px 22px 18px; max-height: 60vh; overflow-y: auto;">
			${SHORTCUTS.map((s) => `
				<div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid var(--e16-border);">
					<div style="font-size: 13.5px; color: var(--e16-text); font-weight: 500;">
						${isAR ? s.ar : s.en}
					</div>
					<div style="display: inline-flex; gap: 4px;">
						${s.keys.map((k) => `
							<kbd style="
								background: var(--e16-surface-2);
								border: 1px solid var(--e16-border);
								border-bottom-width: 2px;
								border-radius: 6px;
								padding: 4px 8px;
								font: 600 12px/1 var(--e16-font-mono, monospace);
								color: var(--e16-text);
								min-width: 28px;
								text-align: center;
								box-shadow: 0 1px 0 rgba(15, 23, 42, .04);
							">${k}</kbd>
						`).join("")}
					</div>
				</div>
			`).join("")}
		</div>
	`;

	root.appendChild(panel);
	root.addEventListener("click", (ev) => { if (ev.target === root) close(); });
	document.body.appendChild(root);

	const onKey = (ev) => {
		if (ev.key === "Escape") {
			close();
			document.removeEventListener("keydown", onKey);
		}
	};
	document.addEventListener("keydown", onKey);
}

export const shortcutsOverlay = {
	mount() {
		document.addEventListener("keydown", (ev) => {
			// Skip if typing in input
			const tag = (ev.target?.tagName || "").toLowerCase();
			if (tag === "input" || tag === "textarea" || ev.target?.isContentEditable) return;

			// `?` key (Shift+/) opens overlay
			if (ev.key === "?" || (ev.shiftKey && ev.key === "/")) {
				ev.preventDefault();
				const isOpen = !!document.getElementById(ROOT_ID);
				if (isOpen) close();
				else open();
			}
		});
	},
	open, close,
};
